export const LANG = {
  EN: 'en',
  RU: 'ru',
}
